<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main>
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>

<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition
  }
};
</script>

<style scoped>
  #app {
    background-image: url("/img/background.png");
    background-size: contain;
  }

  @font-face {
    font-family: "TT Norms";
    src: local("TT Norms"), url("./fonts/TT Norms/TTNormsPro-Regular.ttf");
  }
</style>